var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('v-img',{staticClass:"banner",attrs:{"src":"/images/banner1.jpg","alt":"A Escola","aspect-ratio":"8.0"}},[_c('div',{staticClass:"fill-height fundo"},[_c('h1',[_vm._v(_vm._s(_vm.value))])])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }